var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoduleBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.286,
    height: 19.85,
    viewBox: "0 0 22.286 19.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "module",
    transform: "translate(0 -42.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12047",
    "data-name": "Group 12047",
    transform: "translate(0 42.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49591",
    "data-name": "Path 49591",
    d: "M302.133,168.191l-10.487,3.933v2.292l10.487-3.933Z",
    transform: "translate(-279.847 -162.702)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49592",
    "data-name": "Path 49592",
    d: "M10.487,263.379,0,259.446v2.284l10.487,3.933Z",
    transform: "translate(0 -249.973)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49593",
    "data-name": "Path 49593",
    d: "M291.646,265.663l10.487-3.933v-2.284l-10.487,3.933Z",
    transform: "translate(-279.847 -249.973)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49594",
    "data-name": "Path 49594",
    d: "M10.487,174.415v-2.292L0,168.191v2.292Z",
    transform: "translate(0 -162.702)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49595",
    "data-name": "Path 49595",
    d: "M291.646,354.451v2.456l10.487-3.933v-2.456Z",
    transform: "translate(-279.847 -337.057)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49596",
    "data-name": "Path 49596",
    d: "M10.487,354.451,0,350.518v2.456l10.487,3.933Z",
    transform: "translate(0 -337.057)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49597",
    "data-name": "Path 49597",
    d: "M26.69,50.309l10.487-3.933L26.69,42.443,16.2,46.376Z",
    transform: "translate(-15.547 -42.443)",
    fill: "#4165f6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoduleBlue);
export default __webpack_public_path__ + "static/media/emoduleBlue.4cec41dd79760b45512090d7801a8c67.svg";
export { ForwardRef as ReactComponent };